import { CopyButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CodeSnippet = ({ code }) => {
  return (
    <Styles.Container>
      <Styles.Code>
        <Text type="bodyMonospaced">{code}</Text>
      </Styles.Code>
      <CopyButton info={code} />
    </Styles.Container>
  )
}

export default CodeSnippet
